<template>
  <div class="pb-3 px-6">
    <v-row :justify="flex">
      <v-col cols="12" class="d-flex align-end"
        :class="`justify-${flex} ${padding}`">
        <div class="d-flex align-end">
          <div class="fs-12 font-weight-light black--text mb-1">
            {{ rps !== 'xs' ? 'Per Halaman' : '' }}
          </div>

          <div class="ml-6">
            <v-select
              :style="selected.row < 10 ? 'width: 45px;' : selected.row > 50 ? 'width: 60px;' : 'width: 55px;'"
              single-line
              @input="changePage(selected.row, selected.pagination)"
              hide-details
              :color="set_color"
              :items="[
                {
                  text: 1,
                  value: 1
                },{
                  text: 5,
                  value: 5
                },
                {
                  text: 10,
                  value: 10
                },
                {
                  text: 15,
                  value: 15
                },
                {
                  text: 20,
                  value: 20
                },
                {
                  text: 50,
                  value: 50
                },
                {
                  text: 100,
                  value: 100
                }
              ]"
              item-text="text"
              item-value="value"
              :item-color="set_color"

              vv-uppercase
              
              v-model="selected.row">
            </v-select>
          </div>
        </div>

        <div v-if="rps !== 'xs'"
          class="fs-12 font-weight-light black--text mx-6 mb-1">
          {{ pagination.current > 1 ? (pagination.prev * selected.row) : 1 }}
          -
          {{ pagination.total_display >= selected.row ? pagination.current * selected.row : pagination.total_data }} 
          dari 
          {{ pagination.total_data }}
        </div>

        <div class="d-flex align-end">
          <div>
            <v-btn
              x-small
              icon
              :disabled="pagination.current === 1"
              @click="selected.pagination = 1; changePage(selected.row, selected.pagination);">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
          </div>

          <div>
            <v-btn
              x-small
              icon
              :disabled="pagination.current < 2"
              @click="selected.pagination = selected.pagination-1; changePage(selected.row, selected.pagination);">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </div>

          <div class="mx-3">
            <v-text-field
              :style="selected.pagination < 10 ? 'width: 45px;' : selected.pagination > 50 ? 'width: 60px;' : 'width: 55px;'"
              dense
              height="30"
              :color="set_color"
              hide-details
              type="number"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              min="0"
              placeholder="1"
              @focus="$event.target.select()"

              vv-uppercase

              v-model="selected.pagination"
              v-on:keyup.enter="changePagination()">
            </v-text-field>

            <!-- WITH DROPWDOWN AUTOCOMPLETE -->
            <!-- <v-select
              :style="selected.pagination < 10 ? 'width: 45px;' : selected.pagination > 50 ? 'width: 60px;' : 'width: 55px;'"
              single-line
              hide-details
              :color="set_color"
              :items="pagination.detail"
              :item-color="set_color"

              vv-uppercase
              
              v-model="selected.pagination"
              v-on:change="changePage(selected.row, selected.pagination)">
            </v-select> -->
          </div>

          <div>
            <v-btn
              x-small
              icon
              :disabled="pagination.current >= pagination.total_page"
              @click="selected.pagination = selected.pagination+1; changePage(selected.row, selected.pagination);">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
          
          <div>
            <v-btn
              x-small
              icon
              :disabled="pagination.current === pagination.total_page"
              @click="selected.pagination = pagination.total_page; changePage(selected.row, selected.pagination);">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
          </div>

          <div class="ml-3">
            <v-btn
              x-small
              icon
              @click="reloadPage(selected.row, selected.pagination);">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'pagination-data',
    data () {
      return {
        selected: {
          row: 50,
          pagination: 1
        },
        reload: false
      }
    },
    props: {
      flex: {
        type: String,
        default: 'start'
      },
      padding: {
        type: String,
        default: 'pt-0'
      }
    },
    watch: {
      // 'selected.row': function (val) {
      //   this.selected.pagination = 1
      //   // val = this.$attrs.model.end
      //   // if (this.reload) {
      //     this.changePage(val, this.selected.pagination)
      //   // }
      //   // this.changePage(val, this.selected.pagination)
        
      // }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      pagination () {
        this.selected.pagination = this.$attrs.display.page
        // this.selected.row = this.$attrs.model.end
        this.selected.row = this.$attrs.display.row === undefined ? this.$attrs.display.limit : this.$attrs.display.row
        
        this.$attrs.model.detail = this.$attrs.model.detail.length < 1 ? [1] : this.$attrs.model.detail

        return this.$attrs.model
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {
      // console.log(this.$attrs.model.end)
      // this.selected.row = this.$attrs.display.row
      this.reload = true
    },
    methods: {
      changePagination () {
        let count = this.pagination.detail.length > 0 ? this.pagination.detail[this.pagination.detail.length - 1] : 1,
            select = this.selected.pagination
            
        this.selected.pagination = select < 1 ? 1 : select > count ? count : select
        
        this.changePage(this.selected.row, this.selected.pagination)
      },
      changePage (row, page) {
        this.$emit('changePage', { row: row, page: page })
      },
      reloadPage (row, page) {
        this.$emit('reloadPage', { row: row, page: page })
      }
    }
  }
</script>